/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Assignee selector. Exactly one of user_id or email must be present and non-empty.
 */
export type SetupTaskAssigneeInput = {
  /**
   * Email address to assign before membership exists. Mutually exclusive with user_id.
   */
  email?: string | undefined;
  /**
   * Active organization member to assign. Mutually exclusive with email.
   */
  userId?: string | undefined;
};

/** @internal */
export type SetupTaskAssigneeInput$Outbound = {
  email?: string | undefined;
  user_id?: string | undefined;
};

/** @internal */
export const SetupTaskAssigneeInput$outboundSchema: z.ZodMiniType<
  SetupTaskAssigneeInput$Outbound,
  SetupTaskAssigneeInput
> = z.pipe(
  z.object({
    email: z.optional(z.string()),
    userId: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      userId: "user_id",
    });
  }),
);

export function setupTaskAssigneeInputToJSON(
  setupTaskAssigneeInput: SetupTaskAssigneeInput,
): string {
  return JSON.stringify(
    SetupTaskAssigneeInput$outboundSchema.parse(setupTaskAssigneeInput),
  );
}
